export default function getTagDetails(type){
    // determine tags background-color and name based on type
    switch(type){
        case 'online': 
            return {
                bgcolor: 'bg-primary',
                text: window.$translations['Online Event'],
            };
        case 'partners': 
            return {
                bgcolor: 'bg-gray',
                text: window.$translations['Partners Event'],
            };
        case 'hybrid': 
            return {
                bgcolor: 'bg-secondary',
                text: window.$translations['Hybrid Event'],
            };
        default:
            return {
                bgcolor: 'bg-secondary',
                text: '',
            };
    }
}